import { NgModule } from '@angular/core';
import { ExtraOptions, RouterModule, Routes } from '@angular/router';
//import { AppLayoutComponent } from './layout/app.layout.component';
//import { AuthGuard } from './guards/auth.guard';

const routerOptions: ExtraOptions = {
    anchorScrolling: 'enabled',
    useHash: false,
};

const routes: Routes = [
    { path:'',pathMatch:'full',redirectTo:'modulos' },
    // { path:'**',pathMatch:'full',redirectTo:'notfound' },
    { path: 'landing', loadChildren: () => import('./components/landing/landing.module').then( (m) => m.LandingModule ),},
    { path: 'modulos', loadChildren: () => import('./components/modulos/modulos.module').then( (m) => m.ModulosModule ),},
    //{ path: 'constanciaciqr/:id', loadChildren: () => import('./components/qrcin/qrcin.module').then( (m) => m.QrcinModule ),},
    // { path: 'prueba-correccion-datos', loadChildren: () => import('./components/modulos/form-grados-titulos/solicitar-correccion-datos/solicitar-correccion-datos.module').then((m) => m.SolicitarCorreccionDatosModule)},
    // { path: 'constancia-accionci', loadChildren: () => import('./components/pdf/imprimirconstanciag/imprimirconstanciag.module').then( (m) => m.ImprimirConstanciagModule ),},
    { path: '**', loadChildren: () => import('./components/notfound/notfound.module').then( (m) => m.NotfoundModule ),},
];

@NgModule({
    imports: [RouterModule.forRoot(routes, routerOptions,)],
    exports: [RouterModule],
})
export class AppRoutingModule {}
